import { Suspense } from "react";
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import Routes from "./routes/Routes";
import { BrowserRouter } from "react-router-dom";
import { styled } from "@mui/material";
import { SnackbarProvider } from "notistack";
import ThemeProvider from "./theme";
import { AuthContextProvider } from "./context/AuthContext";
import { HelmetProvider } from "react-helmet-async";

// alert notification
const StyledSnackbarProvider = styled(SnackbarProvider)`
  &.notistack-MuiContent-success {
    background-color: #E2CE8E;
    background: linear-gradient(92.18deg, #E2CE8E 22.55%, #E8D8A4 51.31%, #E2CE8E 78.11%);
    color: #242424;
  }
  ,
  &.notistack-MuiContent {
    box-shadow: none;
    font-weight: 600;
    border-radius: 10px;
    border: 1px solid #383838;
    font-family: Open Sans, sans-serif;
  }
`;

const App = () => {
  return (
    <AuthContextProvider>
      <BrowserRouter>
        <HelmetProvider>
          <ThemeProvider>
            <ScrollToTop />
            <StyledSnackbarProvider
              // iconVariant={{
              //   success: <img src={success} alt="success" />,
              //   error: <img src={error} alt="error" />,
              //   warning: '⚠️',
              //   info: 'ℹ️',
              // }}
              hideIconVariant
              autoHideDuration={3000}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <Suspense fallback={<Loader />}>
                <Routes />
              </Suspense>
            </StyledSnackbarProvider>
          </ThemeProvider>
        </HelmetProvider>
      </BrowserRouter>
    </AuthContextProvider>
  );
};

export default App;
